// extracted by mini-css-extract-plugin
export var editor = "_17-0";
export var flowSidebar = "_49-2";